module.exports = __webpack_public_path__ + "src/img/rm.7e2ea990.svg";